// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__7KhMS","message":"Messages_message__RXejW","text":"Messages_text__Cv2LV","user":"Messages_user__+zR92","me":"Messages_me__kSKKe"};